import React from 'react';
import {Tab, Tabs} from "react-bootstrap";
import {withNamespaces} from "react-i18next";
import NetworkDeviceActions from "../../layouts/Panel/NetworkDevice/_components/NetworkDeviceActionButtons";
import DiagnosticModeButton from "../DiagnosticModeButton";

const HotSpotTooltipContent = ({ t, networkDeviceList }) => {

    let networkDeviceModels = [];
    networkDeviceModels = networkDeviceList;

    return (
        <React.Fragment>
            { networkDeviceModels.length > 1 ? (
                <Tabs id={'network-device-tooltip'}>
                    { networkDeviceModels.map((device) => (
                        <Tab key={device.id} eventKey={device.label} title={device.label}>
                            <div className="p-3 text-left">
                                <h5>
                                    {device.label }
                                </h5>
                                <h6>
                                    <small>{t('type')}: { device.deviceType.label }</small>
                                </h6>
                                <p className='m-0'>
                                    <b>{t('ip-address')}: </b> {device.ipAddress }
                                </p>

                                { device.mac || (
                                    <p className='m-0'>
                                        <b>{t('mac')}: </b> { device.mac }
                                    </p>
                                ) }

                                <div className='mt-3'>
                                    <DiagnosticModeButton size="sm" networkDevice={device} />
                                </div>

                                <div className='mt-3'>
                                    <p><b>{t('actions')}</b></p>
                                    <NetworkDeviceActions size="sm" row={device} />
                                </div>
                            </div>
                        </Tab>
                    )) }
                </Tabs>
            ) : (
                <div className="p-3 text-left">
                    <h5>
                        {networkDeviceModels[0].label }
                    </h5>
                    <h6>
                        <small><b>{t('type')}</b>: { networkDeviceModels[0].deviceType.label }</small>
                    </h6>
                    <p className='m-0'>
                        <b>{t('ip-address')}: </b> {networkDeviceModels[0].ipAddress }
                    </p>

                    { !networkDeviceModels[0].mac || (
                        <p className='m-0'>
                            <b>{t('mac')}: </b> { networkDeviceModels[0].mac }
                        </p>
                    ) }

                    <div className='mt-3'>
                        <DiagnosticModeButton size="sm" networkDevice={networkDeviceModels[0]} />
                    </div>

                    {/*<div className='mt-3'>*/}
                    {/*    <p><b>{t('actions')}</b></p>*/}
                    {/*    <NetworkDeviceActions size="sm" row={networkDeviceModels[0]} />*/}
                    {/*</div>*/}
                </div>
            ) }


        </React.Fragment>
    );
};

export default withNamespaces()(HotSpotTooltipContent);
